export const downloadDocumentTypes = {
    API_RESPONSE_SUCCESS: '@@downloadDocument/API_RESPONSE_SUCCESS',
    API_RESPONSE_ERROR: '@@downloadDocument/API_RESPONSE_ERROR',
    GET_DOCUMENT: '@@documentHistory/GET_DOCUMENT',
};
